export default {
  getUploadToken: {
    method: 'get',
    url: '/api/getUploadToken'
  }
}
